export interface IModuleBlockedActions {
    edit?: boolean;
    delete?: boolean;
    clone?: boolean;
    changeLayout?: boolean;
    fullscreen?: boolean;
    popout?: boolean;
    explain?: boolean;
    download?: boolean;
}

export const CANNOT_EDIT_BLOCKED_ACTIONS: IModuleBlockedActions = {
    edit: true,
};

export const NON_USER_DASHBOARD_BLOCKED_ACTIONS: IModuleBlockedActions = {
    edit: true,
    delete: true,
    changeLayout: true,
};

export const DEFINITION_BLOCKED_ACTIONS: IModuleBlockedActions = {
    edit: true,
    delete: true,
    explain: true,
};

export const CANNOT_POPOUT_BLOCKED_ACTIONS: IModuleBlockedActions = {
    popout: true,
};

export const VIEW_ONLY_BLOCKED_ACTIONS: IModuleBlockedActions = {
    changeLayout: true,
    clone: true,
    edit: true,
    delete: true,
    fullscreen: true,
};

export const VIEW_ONLY_CHART_BLOCKED_ACTIONS: IModuleBlockedActions = {
    changeLayout: true,
    clone: true,
    edit: true,
    delete: true,
};

export const EDITABLE_DASHBOARD_BLOCKED_ACTIONS: IModuleBlockedActions = {
    edit: true,
    fullscreen: true,
};

export const NO_DATA_BLOCKED_ACTIONS: IModuleBlockedActions = {
    fullscreen: true,
    popout: true,
    explain: true,
    download: true,
};

export const NO_ACCESS_BLOCKED_ACTIONS: IModuleBlockedActions = {
    edit: true,
    clone: true,
    changeLayout: true,
    fullscreen: true,
    popout: true,
    download: true,
};
